const model = {
    name: 'Relevance',
    properties: {
        analyzer: { required: true },
        name: { required: true },
        weight: {}, // TODO: >= 0.1 float
    },
};
export default model;
